<ul class="breadcrumb">
  <li class="breadcrumb-item"><a (click)="naviagte('/home')" routerLink="" >Home</a></li>
  <li *ngFor="let breadcrumb of breadcrumbs, index as i" class="breadcrumb-item">
    <img src="../../../assets/images/navigation-arrow.svg" class="navigation-arrow pr-2" alt="arrow" />
    <a *ngIf="breadcrumbs.length - 1 > i  && breadcrumb.navigate" [routerLink]="breadcrumb.url">{{breadcrumb.label}}</a>
    <label *ngIf="breadcrumbs.length - 1 == i || !breadcrumb.navigate">{{breadcrumb.label}}</label>
  </li>
</ul>